export class SidebarConfig {
    private defaults: any = {
        items: [
            {
                title: 'Devices',
                page: '/devices',
                translate: 'menu.devices',
                img:'wifi'
            },
            {
                title: 'Monitoring',
                page: '/monitoring',
                translate: 'menu.monitoring',
                img:'eye'
            },
            {
                title: 'Users',
                page: '/users',
                translate: 'menu.users',
                img:'user'
            },
            {
                title: 'VpnManagement',
                page: '/vpn',
                translate: 'menu.vpn',
                img:'branches'
            },
        ]


    }

    public get configs(): any {
        return this.defaults;
    }
}